import React, { Component } from "react";
import PropTypes from "prop-types";
import { app } from "../base.js";
import ScheduleRetro from "./ScheduleRetro.js";
import Modal from "./Modal.js";
import BecomeMember from "./BecomeMember.js";
import SubscriptionEdit from "./SubscriptionEdit.js";
import CircleIcon from "./CircleIcon.js";
import CopyToClipboard from "./CopyToClipboard.js";
import SectionLabel from "./SectionLabel.js";
import { Loader } from "react-loaders";
import Pluralize from "react-pluralize";
import "./Settings.css";
import "react-select/dist/react-select.css";

class Settings extends Component {
  constructor() {
    super();
    this.state = {
      showFreeModal: false,
      copyToClipboard: false
    };
  }

  componentDidMount = () => {
    window.analytics.track("Views Settings Page");
  };

  handleSignOut = () => {
    app.auth().signOut();

    window.analytics.track("Logs Out");
    window.analytics.reset();
  };

  openCloseFreeModal = bool => {
    this.setState({
      showFreeModal: bool
    });
  };

  copyToClipboard = () => {
    this.setState({
      copyToClipboard: true
    });

    setTimeout(() => {
      this.setState({
        copyToClipboard: false
      });
    }, 5000);

    window.window.analytics.track("Copies Email to Clipboard", {
      source: "settings page"
    });
  };

  contactUsText = () => {
    if (this.props.payment.activeSubscription) {
      return (
        <span>
          Thanks for being a member. Let us know if you have any feedback,
          questions, or need to pause your membership
        </span>
      );
    } else {
      return (
        <span>
          Let us know if you have any feedback, questions, or just want to say
          hello
        </span>
      );
    }
  };

  render() {
    // Because otherwise the whole damn page crashes on reload. Stupid.
    if (!this.props.settings || !this.props.payment || !this.props.user) {
      return null;
    }

    const promptForUpgrade = (
      <div className="upgrade-text-container">
        <div
          className="button-container"
          onClick={() => this.openCloseFreeModal(true)}
        >
          <CircleIcon type="makers" />
          <p className="label">Become a Member</p>
        </div>
        <p className="text">
          You have{" "}
          <span className="emphasis">
            {this.props.settings.freeRetros} free{" "}
            <Pluralize
              singular="Outro"
              count={this.props.settings.freeRetros}
              showCount={false}
            />{" "}
            left.
          </span>{" "}
          Upgrade to host unlimited Outros with your team
        </p>
      </div>
    );

    const promptForUpdateCard = (
      <div className="edit-card-container">
        <SubscriptionEdit
          payment={this.props.payment}
          user={this.props.user}
          content={
            <div className="button-container">
              <CircleIcon type="credit" />
              <p className="label">Update Card</p>
            </div>
          }
          loaderContent={
            <div className="awaiting-update">
              <Loader type="line-scale" active />
            </div>
          }
        />
        <p className="text">
          You're currently using card ending in "{this.props.payment.last4}"
        </p>
      </div>
    );

    return (
      <div>
        <Modal
          showFreeModal={this.state.showFreeModal}
          openCloseFreeModal={this.openCloseFreeModal}
        >
          <BecomeMember
            payment={this.props.payment}
            user={this.props.user}
            openCloseFreeModal={this.openCloseFreeModal}
          />
        </Modal>
        <div className="settings-close-container">
          <div onClick={this.props.history.goBack} className="close">
            Close X
          </div>
          <span />
        </div>
        <div className="settings-container">
          <div className="two-box-container">
            <div className="left-container">
              <SectionLabel text="SCHEDULE OUTRO" />
              <ScheduleRetro
                settings={this.props.settings}
                commitUpdatedSettings={this.props.commitUpdatedSettings}
              />
            </div>
            <div className="right-container">
              <div className="membership-container">
                <SectionLabel text="MEMBERSHIP" />

                {!this.props.payment.activeSubscription
                  ? promptForUpgrade
                  : null}
                <div className="contact-us-container">
                  <div className="copy-to-clipboard-container">
                    <CopyToClipboard
                      copyToClipboard={this.state.copyToClipboard}
                    />
                    <div
                      className="button-container"
                      onClick={this.copyToClipboard}
                    >
                      <CircleIcon type="contact" />
                      <p className="label">Contact Us</p>
                    </div>
                  </div>
                  <p className="text">{this.contactUsText()}</p>
                </div>
                {this.props.payment.activeSubscription
                  ? promptForUpdateCard
                  : null}
                <div className="log-out-container">
                  <div
                    className="button-container"
                    onClick={this.handleSignOut}
                  >
                    <CircleIcon type="log-out" />
                    <p className="label">Log Out</p>
                  </div>
                  <p className="text">
                    You're signed in as{" "}
                    <span className="email">{this.props.user.email}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Settings.propTypes = {
  settings: PropTypes.shape({
    teamName: PropTypes.string,
    frequency: PropTypes.oneOf(["weekly", "bi-weekly", "monthly", "other"])
      .isRequired,
    day: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]).isRequired,
    time: PropTypes.isRequired,
    freeRetros: PropTypes.number.isRequired
  }),
  commitUpdatedSettings: PropTypes.func.isRequired,
  payment: PropTypes.shape({
    activeSubscription: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    last4: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    stripeWebhookProcessedOn: PropTypes.number,
    stripeCustomerID: PropTypes.string.isRequired
  })
};

export default Settings;



// WEBPACK FOOTER //
// ./src/components/Settings.js